var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconColorNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 18,
    viewBox: "0 0 22.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-fiber-new",
    "data-name": "Icon material-fiber-new",
    d: "M23.25,6h-18A2.233,2.233,0,0,0,3.011,8.25L3,21.75A2.242,2.242,0,0,0,5.25,24h18a2.242,2.242,0,0,0,2.25-2.25V8.25A2.242,2.242,0,0,0,23.25,6ZM10.313,18.375H8.962L6.094,14.438v3.938H4.688v-6.75H6.094l2.813,3.938V11.625h1.406Zm5.625-5.333H13.125V14.3h2.813V15.72H13.125v1.249h2.813v1.406h-4.5v-6.75h4.5v1.418Zm7.875,4.208a1.128,1.128,0,0,1-1.125,1.125h-4.5a1.128,1.128,0,0,1-1.125-1.125V11.625h1.406V16.7H19.74v-3.96h1.406v3.949h1.26V11.625h1.406Z",
    transform: "translate(-3 -6)",
    fill: "#024D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorNew);
export default __webpack_public_path__ + "static/media/icon-color-new.f131b7cb95d6cc72dc2909ea32ce908b.svg";
export { ForwardRef as ReactComponent };